__turbopack_context__.v({
  "close": "Toast-module-scss-module__Lti1Pq__close",
  "content": "Toast-module-scss-module__Lti1Pq__content",
  "description": "Toast-module-scss-module__Lti1Pq__description",
  "error": "Toast-module-scss-module__Lti1Pq__error",
  "fade-in": "Toast-module-scss-module__Lti1Pq__fade-in",
  "info": "Toast-module-scss-module__Lti1Pq__info",
  "no-transform": "Toast-module-scss-module__Lti1Pq__no-transform",
  "root": "Toast-module-scss-module__Lti1Pq__root",
  "rotate": "Toast-module-scss-module__Lti1Pq__rotate",
  "success": "Toast-module-scss-module__Lti1Pq__success",
  "title": "Toast-module-scss-module__Lti1Pq__title",
  "toast-hide": "Toast-module-scss-module__Lti1Pq__toast-hide",
  "toast-viewport": "Toast-module-scss-module__Lti1Pq__toast-viewport",
  "viewport": "Toast-module-scss-module__Lti1Pq__viewport",
  "warning": "Toast-module-scss-module__Lti1Pq__warning",
});
